// Words for pieces. The engine, the spells, and the UI all use these.

import { KIND_NAMES } from './abilities';
import { squareName } from './squares';
import type { Owner, Piece } from './types';

/**
 * What the player reads. The ids keep the first names, `gold` and `violet`,
 * so a saved match and every class name still hold.
 */
export const OWNER_NAMES: Record<Owner, string> = {
  gold: 'Sun',
  violet: 'Moon',
  neutral: 'Nobody',
};

/** "Sun's pawn on e4", or "the blocker on e4" for a neutral piece. */
export const describePiece = (piece: Piece, square: number): string => {
  const name = KIND_NAMES[piece.kind];
  const owner = piece.owner === 'neutral' ? 'the' : `${OWNER_NAMES[piece.owner]}'s`;
  return `${owner} ${name} on ${squareName(square)}`;
};
